<template>
    <v-container fluid class="pr-0 pl-0">
        <client-only>
            <v-row column justify-center align-center>
                <v-col v-if="isLoggedIn" cols="12">
                    <TranslatableBlockComponent
                        :tstring="{ string: 'loggedInMessage' }"
                    />
                </v-col>
                <v-col v-else cols="12">
                    <v-card class="mx-auto mt-5" width="500">
                        <v-progress-linear
                            v-if="loader"
                            indeterminate
                            color="#0063a6"
                        ></v-progress-linear>
                        <v-card-text class="pa-0">
                            <ValidationObserver
                                ref="observer"
                                v-slot="{ handleSubmit }"
                            >
                                <v-form
                                    id="accountSignup"
                                    ref="accountSignup"
                                    data-netlify="true"
                                    data-netlify-honeypot="bot-field"
                                    name="accountSignup"
                                    action="/register/"
                                    method="POST"
                                    @submit.prevent="handleSubmit(handleSignup)"
                                >
                                    <input
                                        id="form-name"
                                        v-model="signupCreds.formName"
                                        type="hidden"
                                        name="form-name"
                                        value="accountSignup"
                                    />
                                    <v-container>
                                        <v-row>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="6"
                                            >
                                                <ValidationProvider
                                                    name="accountFirstName"
                                                    rules="required"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <v-text-field
                                                            id="accountFirstName"
                                                            v-model="
                                                                signupCreds.firstName
                                                            "
                                                            name="accountFirstName"
                                                            :label="
                                                                localize(
                                                                    'firstName'
                                                                )
                                                            "
                                                            :hint="
                                                                hints.accountFirstName
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-user-circle
                                                            </v-icon></v-text-field
                                                        >
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="6"
                                            >
                                                <ValidationProvider
                                                    name="accountLastName"
                                                    rules="required"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <v-text-field
                                                            id="accountLastName"
                                                            v-model="
                                                                signupCreds.lastName
                                                            "
                                                            name="accountLastName"
                                                            :label="
                                                                localize(
                                                                    'lastName'
                                                                )
                                                            "
                                                            :hint="
                                                                hints.accountLastName
                                                            "
                                                        ></v-text-field>
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                            >
                                                <ValidationProvider
                                                    name="accountEmail"
                                                    rules="required|email|nonPlussedEmail|emoji"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <v-text-field
                                                            id="accountEmail"
                                                            v-model="
                                                                signupCreds.email
                                                            "
                                                            name="accountEmail"
                                                            :label="
                                                                localize(
                                                                    'email'
                                                                )
                                                            "
                                                            :hint="
                                                                hints.accountEmail
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-envelope
                                                            </v-icon></v-text-field
                                                        >
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                            >
                                                <ValidationProvider
                                                    name="accountPassword"
                                                    rules="required"
                                                    class="validationWrapper"
                                                    vid="confirmation"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <!-- id="accountPassword" -->
                                                        <!-- name="accountPassword" -->
                                                        <v-text-field
                                                            v-model="
                                                                signupCreds.password
                                                            "
                                                            :label="
                                                                localize(
                                                                    'password'
                                                                )
                                                            "
                                                            :type="
                                                                showPassword
                                                                    ? 'text'
                                                                    : 'password'
                                                            "
                                                            :hint="
                                                                hints.accountPassword
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-lock
                                                            </v-icon>
                                                            <template
                                                                v-slot:append
                                                            >
                                                                <span
                                                                    tabindex="-1"
                                                                    style="
                                                                        cursor: pointer;
                                                                    "
                                                                    @click="
                                                                        showPassword = !showPassword
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-if="
                                                                            showPassword
                                                                        "
                                                                        dense
                                                                        >fa-eye</v-icon
                                                                    >
                                                                    <v-icon
                                                                        v-else
                                                                        dense
                                                                        >fa-eye-slash</v-icon
                                                                    >
                                                                </span>
                                                            </template></v-text-field
                                                        >
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                            >
                                                <ValidationProvider
                                                    name="confirmPassword"
                                                    rules="required|confirmed:confirmation"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <!-- id="accountPassword" -->
                                                        <!-- name="accountPassword" -->
                                                        <v-text-field
                                                            v-model="
                                                                signupCreds.confirmation
                                                            "
                                                            :label="
                                                                localize(
                                                                    'confirmPassword'
                                                                )
                                                            "
                                                            :type="
                                                                showConfirmationPassword
                                                                    ? 'text'
                                                                    : 'password'
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-lock
                                                            </v-icon>
                                                            <template
                                                                v-slot:append
                                                            >
                                                                <span
                                                                    tabindex="-1"
                                                                    style="
                                                                        cursor: pointer;
                                                                    "
                                                                    @click="
                                                                        showConfirmationPassword = !showConfirmationPassword
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-if="
                                                                            showConfirmationPassword
                                                                        "
                                                                        dense
                                                                        >fa-eye</v-icon
                                                                    >
                                                                    <v-icon
                                                                        v-else
                                                                        dense
                                                                        >fa-eye-slash</v-icon
                                                                    >
                                                                </span>
                                                            </template></v-text-field
                                                        >
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                v-if="justRegistered"
                                                cols="12"
                                            >
                                                <TranslatableBlockComponent
                                                    :tstring="{
                                                        string:
                                                            'checkEmailForConfirmationMail',
                                                    }"
                                                />
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                                :class="{
                                                    'py-0':
                                                        $vuetify.breakpoint
                                                            .smAndDown,
                                                    'd-flex': true,
                                                    'justify-center': true,
                                                }"
                                            >
                                                <recaptcha
                                                    @success="onSuccess"
                                                    @error="onError"
                                                    @expired="onExpired"
                                                />
                                                <div
                                                    v-if="captchaError"
                                                    class="captcha-error"
                                                >
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'captchaRequired',
                                                        }"
                                                    />
                                                </div>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                                class="py-0"
                                            >
                                                <v-btn
                                                    type="submit"
                                                    color="success"
                                                    :disabled="loader"
                                                    block
                                                    ><TranslatableStringComponent
                                                        :tstring="{
                                                            string: 'register',
                                                        }"
                                                /></v-btn>
                                            </v-col>
                                            <v-col
                                                v-if="!justRegistered"
                                                cols="12"
                                                class="text-sm-center"
                                            >
                                                <span>
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'alreadyHaveAnAccount',
                                                        }"
                                                    />
                                                    <nuxt-link
                                                        :to="
                                                            getStaticLocalePath(
                                                                {
                                                                    type:
                                                                        'page',
                                                                    slugName:
                                                                        'login',
                                                                }
                                                            )
                                                        "
                                                        ><TranslatableStringComponent
                                                            :tstring="{
                                                                string: 'login',
                                                            }"
                                                    /></nuxt-link>
                                                </span>
                                                <div
                                                    class="registration-notice"
                                                >
                                                    <TranslatableBlockComponent
                                                        :tstring="{
                                                            string:
                                                                'registrationNote',
                                                        }"
                                                    />
                                                </div>
                                                <small class="mt-2">
                                                    <nuxt-link
                                                        :to="
                                                            getStaticLocalePath(
                                                                {
                                                                    type:
                                                                        'page',
                                                                    slugName:
                                                                        'contact',
                                                                }
                                                            )
                                                        "
                                                    >
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'contactCustomerFirst',
                                                            }"
                                                        />
                                                    </nuxt-link>
                                                </small>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </client-only>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import handleAuth from '~/mixins/handleAuth'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import handleSnackbar from '~/mixins/handleSnackbar'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
import {
    RecaptchaVerificationFailedError,
    NetlifyDownError,
} from '~/util/Exceptions'

export default {
    name: 'FormRegister',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    mixins: [handleAuth, handleRecaptcha, handleSnackbar],
    data() {
        return {
            showPassword: false,
            showConfirmationPassword: false,
            signupCreds: {
                name: null,
                email: null,
                password: null,
                confirmation: null,
                formName: 'accountSignup',
                firstName: null,
                lastName: null,
                token: null,
            },
            hints: {
                accountFirstName: this.localize('yourFirstName'),
                accountLastName: this.localize('yourLastName'),
                accountEmail: this.localize('weRespectYourPrivacy'),
                accountPassword: this.localize('pleaseSetAStrongPassword'),
            },
            loader: false,
        }
    },
    computed: {},
    watch: {
        'signupCreds.firstName'() {
            this.updateNameField()
        },
        'signupCreds.lastName'() {
            this.updateNameField()
        },
    },
    mounted() {
        if (process.browser) {
            window.onNuxtReady((app) => {
                if (
                    window.location.hash.split('confirmation_token=').length ===
                    2
                ) {
                    const token = window.location.hash.split(
                        'confirmation_token='
                    )[1]
                    this.$store.commit('auth/COOKIE_THE_TOKEN', token)
                    // console.log('A cookie should have been set here.')
                }
            })
        }
    },
    methods: {
        ...mapActions('auth', ['attemptSignUp', 'checkNetlifyStatus']),
        async handleSignup() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            this.loader = true
            try {
                const name = this.signupCreds.firstName
                const data = await this.$axios.$post(
                    'reCaptcha-server-side-validation',
                    {
                        token: this.token,
                    }
                )
                const axiosConfig = {
                    header: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
                if (data && data.success === false)
                    throw new RecaptchaVerificationFailedError(data)
                // await this.checkNetlifyStatus()

                await this.attemptSignUp(this.signupCreds, this)

                const hubspotPayload = {
                    formObject: {
                        'form-name': 'Registration Form V2',
                        firstname: this.signupCreds.firstName,
                        lastname: this.signupCreds.lastName,
                        email: this.signupCreds.email,
                    },
                    hubspotutk: Cookies.get('hubspotutk') || 0,
                }
                await this.$axios.post(
                    'submit-hubspot-form',
                    hubspotPayload,
                    axiosConfig
                )
                // const crmPayload = {
                //     'form-name': 'accountSignup',
                //     'name.first': this.signupCreds.firstName,
                //     'name.last': this.signupCreds.lastName,
                //     email: this.signupCreds.email,
                // }
                // await this.$axios.post('submitted-web-form', crmPayload, {
                //     params: {
                //         obj: 'y',
                //     },
                // })
                this.logGTMevent()
                this.loader = false
                this.resetForm('accountSignup')
                this.$recaptcha.reset()
                this.hitSnackbar(
                    {
                        string: [
                            'welcome',
                            'pleaseCheckYourEmailToConfirmRegistration',
                        ],
                        variables: [[{ var: name }]],
                    },
                    {}
                )
            } catch (error) {
                let errorMessage = ''
                if (error instanceof NetlifyDownError) {
                    errorMessage = 'netlifyIdentityError'
                } else if (error instanceof RecaptchaVerificationFailedError) {
                    errorMessage = 'recaptchaFailedMessage'
                } else {
                    errorMessage = 'emailAddressRegistered'
                }
                this.handleErrors(errorMessage)
            }
        },
        handleErrors(errorMessage) {
            this.$recaptcha.reset()
            this.loader = false
            this.hitSnackbar({ string: errorMessage }, {})
            this.$apm?.captureError(errorMessage)
        },
        encode(data) {
            return Object.keys(data)
                .map(
                    (key) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(
                            data[key]
                        )}`
                )
                .join('&')
        },
        updateNameField() {
            const firstName = this.signupCreds.firstName || ''
            const lastName = this.signupCreds.lastName || ''
            this.signupCreds.name = (firstName + ' ' + lastName).trim()
        },
        logGTMevent() {
            gtmEvent({
                gtm: this.$gtm,
                event: 'accountSignup',
                eventType: 'form',
                atts: {
                    firstName: this.signupCreds.firstName,
                    lastName: this.signupCreds.lastName,
                },
            })
        },
    },
}
</script>
<style scoped>
.registration-notice {
    background-color: #efefef;
    margin: 1em 0 0.5em 0;
    padding: 0.5em 0;
    border-radius: 5px;
}
</style>
